import React, { ChangeEvent, useEffect, useState } from "react";
import SweetAlertModal from "../../components/SweetAlertModal/SweetAlertModal.js";

import Typography from "@mui/material/Typography";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  DialogContentText,
  DialogTitle,
  Grid,
  TextField,
  Switch,
} from "@mui/material";

import AutoCompleteMultiSelect from "../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";

import "./AddItem.css";

import Cancel from "./../../../assets/icons/close.png";
import CancelIcon from "@mui/icons-material/Cancel";
import { uploadOneFiles } from "../../../fileUploader/SingleFileUploader.js";

import ChickenIcon from "./../../../assets/icons/turkey.png";
import galleryIcon from "./../../../assets/icons/gallery.png";
import ChickenLegIcon from "./../../../assets/icons/chicken-leg.png";
import Burger1Icon from "./../../../assets/icons/burger1.png";
import Burger2Icon from "./../../../assets/icons/burger.png";
import FullPizzaIcon from "./../../../assets/icons/pizza.png";
import pizzaIcon from "./../../../assets/icons/pizza (1).png";
import { getMinimalContentHeight } from "@mui/x-data-grid/hooks/features/rows/gridRowsUtils.js";
import SectionTableSubSection from "./SectionTableSubSection.tsx";
import CustomDialog from "../../components/CustomDialog/CustomDialog.tsx";
import AddRestaurantDialog from "../../restaurantsetup/components/AddRestaurantDialog/AddRestaurantDialog.tsx";
import itemImg from "./../../../assets/icons/menu.png";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import jwt_decode from "jwt-decode";
import preloader from "./../../../assets/images/LoadingSpin.gif";

import ArchiveDialog from './AddMenu/ArchiveDialog.tsx';
import MenuCopyDialog from './CopyDialog/MenuCopyDialog.tsx';
import { Kitchen, Title } from '@mui/icons-material';
import MenuLinkDialog from '../components/MenuLinkDialog.tsx';
import SchedulerComponent from "../components/SchedulerView/ScheduleItemDialog/SchedulerComponent/SchedulerComponent.tsx";
import MenuSchedulerSelectDialog from "../components/AddMenu/EditMenuSchedulerDialog.tsx";
import EditMenuDelivery from "./EditMenuDelivery.tsx";
import LoadingView from "../../components/LoadingView/LoadingView.js";

function EditMenuDialog(props) {
  console.log(props.eidtData);
  const [defaultData, setDefaultData] = useState(props.eidtData);
  const [EditData, setEditData] = useState(props.eidtData.obj);
  //test start

  const [selectedSectionValue, setSelectedSectionValue] = useState<any>(null);
  const [selectedData, setSelectedData] = useState({});
  const [keyword, setKeyword] = useState(null);
  const [imageMap, setimageMap] = useState([]);
  const [typrOfMenuDatas, setTyprOfMenuDatas] = useState([]);
  const [restaurantId, setRestaurantId] = useState([]);
  const [loadingModal, SetloadingModal] = React.useState(false);
  const apiAddress = process.env.REACT_APP_SECRET;

  const token = jwt_decode(localStorage.getItem("gotasteadmintoken"));

  const handleAutocompleteSectionChange = (
    event: ChangeEvent<{}>,
    value: any
  ) => {
    setSelectedSectionValue(value);
  };
  const handleKeyword = (event) => {
    setKeyword(event.target.value);
  };

  const [sectionDatas, setSectionDatas] = useState([]);
  const [selectedValue, setSelectedValue] = useState(
    defaultData ? defaultData.iconObj : null
  );
  const handleAutocompleteChange = (event: ChangeEvent<{}>, value: any) => {
    setSelectedValue(value);
  };

  console.log(EditData)

  const loadRestaurant = () => {
    axios
      .get(apiAddress + "/api/RestaurantUserMapper/getbyuserid/" + token.UserId)
      .then((response) => {
        console.log(response.data);

        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.restaurantId,
            title: dt.restaurantName,
          };
          list.push(obj);
        });
        setSectionDatas(list);
      });
  };

  useEffect(() => {}, []);

  var obj = {
    Id: "123",
    MenuName: "",
    MenuTypeId: "",
    IconId: "",
    KitchenId: 0,
    //IsActive: true,
    CreationId: "1",
    RestaurantIdList: [],
  };
  const fileUpload = async (data) => {
    console.log(data);
    var res = await uploadOneFiles(data[0]);
    return res;
  };

  const [state, setState] = useState<ImageUploadState>({
    selectedImages: [props.eidtData.obj.url] || [],
  });

  console.log(state.selectedImages);

  // const onClickUpdate = async () => {
  //   if (!keyword) {
  //     toast.error("Name is required", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  //     return;
  //   }
  
  //   if (state.selectedImages.length <= 0) {
  //     toast.error("Icon is required", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  //     return;
  //   }
  
  //   const allMenus = [{ ...EditData, isMain: true }, ...linkedMenuAdded];
  //   const hasEmptyMenuType = allMenus.some((menu) => {
  //     const types = menuType[menu.id] || [];
  //     return types.length === 0; // Check if no menu types are selected
  //   });
  
  //   if (hasEmptyMenuType) {
  //     toast.error("Menu type is required for each Menu", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  //     return;
  //   }
  
  //   if (menuIds.length <= 0) {
  //     toast.error("Kitchen is required", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  //     return;
  //   }
  
  //   const isLinkgageUpdate = linkedMenuAdded.length > 0;
  
  //   const reqBody = [];
  //   if (initMenuName !== keyword) {
  //     reqBody.push({
  //       columnName: "MenuName",
  //       columnValue: keyword,
  //     });
  //   }
  
  //   if (initIcon !== state.selectedImages[0]) {
  //     const logoUrl = await fileUpload(logoImg);
  //     reqBody.push({
  //       columnName: "IconId",
  //       columnValue: logoUrl[0],
  //     });
  //   }
  
  //   const menuTypeUpdateBody = [
  //     // Update main menu types
  //     ...restaurantAdded.map((restaurant) => ({
  //       id: "",
  //       restaurantId: restaurant.id,
  //       menuId: EditData.id,
  //       menuTypeId: menuType[EditData.id]?.map((type) => type.id),
  //       isActive: true,
  //       creationId: "1",
  //     })),
    
  //     // Update linked menus' types
  //     ...linkedMenuAdded.map((linkedMenu) => ({
  //       id: "",
  //       restaurantId: linkedMenu.linkedRestaurantId, 
  //       menuId: linkedMenu.id, 
  //       menuTypeId: menuType[linkedMenu.id]?.map((type) => type.id) || [],
  //       isActive: true,
  //       creationId: "1",
  //     })),
  //   ];
    
  //   console.log(menuTypeUpdateBody)
  
  //   try {
    
  //     await axios.put(`${apiAddress}/api/Menu/UpdateMenuType`, menuTypeUpdateBody);
  
  //     await axios.put(
  //       `${apiAddress}/api/Menu/updateMenuItems?id=${EditData.id}&updateLinkage=${isLinkgageUpdate}`,
  //       reqBody
  //     );
  
  //     toast.success("Successfully updated", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  
  //     props.onHandleAddItem(false);
  //   } catch (error) {
  //     console.error("Error updating menu:", error);
  //     toast.error("Failed to update menu", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  //   }
  // };

  // const onClickUpdate = async () => {
  //   if (!keyword) {
  //     toast.error("Name is required", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  //     return;
  //   }
  
  //   if (state.selectedImages.length <= 0) {
  //     toast.error("Icon is required", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  //     return;
  //   }
  
  //   const allMenus = [{ ...EditData, isMain: true }, ...linkedMenuAdded];
  //   const hasEmptyMenuType = allMenus.some((menu) => {
  //     const types = menuType[menu.id] || [];
  //     return types.length === 0; // Check if no menu types are selected
  //   });
  
  //   if (hasEmptyMenuType) {
  //     toast.error("Menu type is required for each Menu", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  //     return;
  //   }
  
  //   if (menuIds.length <= 0) {
  //     toast.error("Kitchen is required", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  //     return;
  //   }
  
  //   // Step 1: Check if "Delivery" is in the menu types for each menu
  //   const updateDeliveryPromises = allMenus.map(async (menu) => {
  //     const types = menuType[menu.id] || [];
  //     const hasDeliveryType = types.some((type) => type.title.toLowerCase() === "delivery");
  
  //     // If "Delivery" is not in the menu types, update isDelivery and isCollectionOnly to false
  //     if (!hasDeliveryType) {
  //       const url = `${apiAddress}/api/Menu/UpdateMenuIsDelivery?menuId=${menu.id}`;
  //       const payload = {
  //         menuId: menu.id,
  //         isDelivery: false,
  //         isCollectionOnly: false,
  //       };
  
  //       return axios.put(url, payload);
  //     }
  //     return Promise.resolve(); // No action needed if "Delivery" is present
  //   });
  
  //   try {
  //     // Step 2: Execute all delivery update promises
  //     await Promise.all(updateDeliveryPromises);
  
  //     // Step 3: Proceed with the main update logic
  //     const isLinkgageUpdate = linkedMenuAdded.length > 0;
  
  //     const reqBody = [];
  //     if (initMenuName !== keyword) {
  //       reqBody.push({
  //         columnName: "MenuName",
  //         columnValue: keyword,
  //       });
  //     }
  
  //     if (initIcon !== state.selectedImages[0]) {
  //       const logoUrl = await fileUpload(logoImg);
  //       reqBody.push({
  //         columnName: "IconId",
  //         columnValue: logoUrl[0],
  //       });
  //     }
  
  //     const menuTypeUpdateBody = [
  //       // Update main menu types
  //       ...restaurantAdded.map((restaurant) => ({
  //         id: "",
  //         restaurantId: restaurant.id,
  //         menuId: EditData.id,
  //         menuTypeId: menuType[EditData.id]?.map((type) => type.id),
  //         isActive: true,
  //         creationId: "1",
  //       })),
  
  //       // Update linked menus' types
  //       ...linkedMenuAdded.map((linkedMenu) => ({
  //         id: "",
  //         restaurantId: linkedMenu.linkedRestaurantId,
  //         menuId: linkedMenu.id,
  //         menuTypeId: menuType[linkedMenu.id]?.map((type) => type.id) || [],
  //         isActive: true,
  //         creationId: "1",
  //       })),
  //     ];
  
  //     console.log(menuTypeUpdateBody);
  
  //     await axios.put(`${apiAddress}/api/Menu/UpdateMenuType`, menuTypeUpdateBody);
  
  //     await axios.put(
  //       `${apiAddress}/api/Menu/updateMenuItems?id=${EditData.id}&updateLinkage=${isLinkgageUpdate}`,
  //       reqBody
  //     );
  
  //     toast.success("Successfully updated", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  
  //     props.onHandleAddItem(false);
  //   } catch (error) {
  //     console.error("Error updating menu:", error);
  //     toast.error("Failed to update menu", {
  //       position: "top-right",
  //       autoClose: 5000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       pauseOnHover: true,
  //       draggable: true,
  //       progress: undefined,
  //       theme: "colored",
  //     });
  //   }
  // };



  const onClickUpdate = async () => {
    SetloadingModal(true);
    if (!keyword) {
      toast.error("Name is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }
  
    if (state.selectedImages.length <= 0) {
      toast.error("Icon is required", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }
  
    // const allMenus = [{ ...EditData, isMain: true }, ...linkedMenuAdded];
    // const hasEmptyMenuType = allMenus.some((menu) => {
    //   const types = menuType[menu.id] || [];
    //   return types.length === 0; // Check if no menu types are selected
    // });
  
    // if (hasEmptyMenuType) {
    //   toast.error("Menu type is required for each Menu", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    //   });
    //   return;
    // }
  
    // if (menuIds.length <= 0) {
    //   toast.error("Kitchen is required", {
    //     position: "top-right",
    //     autoClose: 5000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     draggable: true,
    //     progress: undefined,
    //     theme: "colored",
    //   });
    //   return;
    // }
  
    // Step 1: Check if "Delivery" is the only selected menu type or not selected at all
    // const updateDeliveryPromises = allMenus.map(async (menu) => {
    //   const types = menuType[menu.id] || [];
    //   const hasDeliveryType = types.some((type) => type.title.toLowerCase() === "delivery");
    //   const isOnlyDeliverySelected =
    //     types.length === 1 && hasDeliveryType;
  
    //   // If "Delivery" is the only selected type, update isDelivery and isCollectionOnly to true
    //   if (isOnlyDeliverySelected) {
    //     const url = `${apiAddress}/api/Menu/UpdateMenuIsDelivery?menuId=${menu.id}`;
    //     const payload = {
    //       menuId: menu.id,
    //       isDelivery: true,
    //       isCollectionOnly: true,
    //     };
  
    //     return axios.put(url, payload);
    //   }
  
    //   // If "Delivery" is not selected at all, update isDelivery and isCollectionOnly to false
    //   if (!hasDeliveryType) {
    //     const url = `${apiAddress}/api/Menu/UpdateMenuIsDelivery?menuId=${menu.id}`;
    //     const payload = {
    //       menuId: menu.id,
    //       isDelivery: false,
    //       isCollectionOnly: false,
    //     };
  
    //     return axios.put(url, payload);
    //   }
  
    //   // If "Delivery" is selected along with other types, do not update isDelivery and isCollectionOnly
    //   return Promise.resolve();
    // });
  
    try {
    const reqBody = [];
    if (initMenuName !== keyword) {
      reqBody.push({ columnName: "MenuName", columnValue: keyword });
    }
    if (initIcon !== state.selectedImages[0]) {
      const logoUrl = await fileUpload(logoImg);
      reqBody.push({ columnName: "IconId", columnValue: logoUrl[0] });
    }

    // Only update basic menu fields — no menu types, no kitchens, no delivery logic
    await axios.put(
      `${apiAddress}/api/Menu/updateMenuItems?id=${EditData.id}&updateLinkage=false`,
      reqBody
    );

    toast.success("Successfully updated", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    props.onHandleAddItem(false);
  } catch (error) {
      console.error("Error updating menu:", error);
      toast.error("Failed to update menu", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      SetloadingModal(false);
    }
  };



  //test end

  //dialog start
  const [openIconDilaog, setOpenIconDialog] = useState(false);
  const [openRestaurantDialog, setRestaurantDialog] = useState(false);

  const handleDialogOpen = (name) => {
    if (name == "icon") {
      setOpenIconDialog(true);
    } else if (name == "restaurant") {
      setRestaurantDialog(true);
    }
  };

  const handleDialog = () => {
    setOpenIconDialog(false);
    setRestaurantDialog(false);
    setopenArchiveDilaog(false);
    setopenMenuCopyDilaog(false);
    setRestaurantAdded(initrestaurantAdded);
    setlinkedMenuAdded(initlinkedMenuAdded);
    getLinkedMenuInfoByMenuId();
  }
  
  const handleAddItem = () => {
    setRestaurantDialog(false);
  };

  const handleAddArchiveItem = () => {
    setopenArchiveDilaog(false);
    setopenMenuCopyDilaog(false);
    setRestaurantAdded(initrestaurantAdded)

  }


  const handleClose = () => {
    const areArraysEqual = (initrestaurantAdded, restaurantAdded) => {
      if (initrestaurantAdded.length !== restaurantAdded.length) {
        return false;
      }

      const sortedArray1 = initrestaurantAdded
        .slice()
        .sort((a, b) => a.id - b.id);
      const sortedArray2 = restaurantAdded.slice().sort((a, b) => a.id - b.id);

      return sortedArray1.every(
        (obj1, index) => obj1.id === sortedArray2[index].id
      );
    };

    if (
      areArraysEqual(initrestaurantAdded, restaurantAdded) &&
      initMenuName == keyword &&
      initIcon == selectedValue &&
      initManuType == menuTypeName
    ) {
      props.onHandleAddItem(false);
    } else {
      setopenMenuCloseConfirmaitonModal(true);
    }

    // props.onHandleAddItem(false)
    // setKeyword(null)
    // setSelectedValue(null)
  };

  const handleEditDialogClose = () => {
    props.onHandleAddItem(false);
    //setKeyword(null)
    setSelectedValue(null);
  };
  const [autoCompleteValue, setAutoCompleteValue] = React.useState([]);
  const [menuType, setMenuType] = useState({});

  const [menuIds, setMenuIds] = useState([]);
  const [initKitchenId, setinitKitchenId] = useState([]);

  const addValue = (props) => {
    setAutoCompleteValue(props);
    console.log(menuIds);

    if (
      menuIds.length > 0 &&
      props.length > 0 &&
      props.length > menuIds.length
    ) {
      const data = menuIds.find(
        (x) => x.restaurantId == props[props.length - 1].restaurantId
      );
      console.log(props);

      if (data) {
        toast.error("Kitchen already Add For the resturant", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        setMenuIds(props);
      }
    } else {
      setMenuIds(props);
    }
  };
  const [menuData, setMenuData] = useState([]);
  const [allMenuData, setAllMenuData] = useState([]);

  const [menuTypeName, setMenuTypeName] = useState();
  console.log(menuType)
  // const addMenuType = (props) => {
  //   console.log(props);
  //   typrOfMenuDatas.map((data, index) => {
  //     if (data.title == props) {
  //      // setMenuType(data.id);
  //      setMenuType({ id: data.id, title: data.title });
  //     }
  //   });
  //   //     const [kitchen, setKichen] = useState();

  //   //     const addKitchen = () =>{

  //   //  }
  // };

  const handleMenuChange = (menuId, newValue) => {
    setMenuType((prev) => ({
      ...prev,
      [menuId]: newValue, // Store selected menus for the restaurant
    }));
  };
  
  console.log(autoCompleteValue);
  console.log(menuType);
  const renderOption = (option) => (
    <Grid container alignItems="center">
      <Grid item>
        <img src={option.icon} alt="Icon" style={{ width: "1rem" }} />
      </Grid>
      <Grid item>
        <Typography>{option.title}</Typography>
      </Grid>
    </Grid>
  );

  const { open, onClose, dialogType, id } = props;

  type Restaurant = {
    id: string;
    title: string;
  };

  //const [restaurantAdded, setRestaurantAdded] = useState<Restaurant>();
  const [restaurantAdded, setRestaurantAdded] = useState([]);
  const [linkedMenuAdded, setlinkedMenuAdded] = useState([]);
  const [initlinkedMenuAdded, setinitlinkedMenuAdded] = useState([]);
  const [LinkedMenuDatas, setLinkedMenuDatas] = useState([]);
  const [initLinkedMenuDatas, setinitLinkedMenuDatas] = useState([]);
  const [linkedMenudatas2, setlinkedMenudatas2] = useState([]);
  const [linkedMenudatas3, setlinkedMenudatas3] = useState([]);
  const [restaurantDatas, setRestaurantDatas] = React.useState([]);

  useEffect(() => {
    const fetchData = async () => {
      await loadRestaurantName();
      await getLinkedMenuInfoByMenuId();
    };
    fetchData();
    var menutypes = [];

    loadRestaurant();
    axios
      .get(apiAddress + "/api/Menu/GetAllMenuTypeListAsync")
      .then((response) => {
        console.log(response.data);

        var list = [];
        response.data.map((dt, i) => {
          var obj = { id: dt.id, title: dt.typeName };
          list.push(obj);
        });
        console.log(list);
        setTyprOfMenuDatas(list);

        console.log(typrOfMenuDatas);
      });

    console.log(menutypes);

    console.log(props.eidtData);

    if (!!props.eidtData == true) {
      console.log(props.eidtData.obj.id);
      setSelectedRowId(props.eidtData.obj?.id);
      console.log(selectedRowId);
      setSelectedValue(props.eidtData.iconObj);
      setinitIcon(props.eidtData.obj.url);
      if (!!props.eidtData.obj == true) {
        console.log(props.eidtData.obj);

        setKeyword(props.eidtData.obj.menuName);
        setinitMenuName(props.eidtData.obj.menuName);

        let list = []
        let schedulelist = []

        var obj = {
          id: '123',
          foodItemId: props.eidtData.obj.id,
          schedulerId: props.eidtData.obj.scheduleId,
          quantity: 10,
          creationId: '123',
        };

        var scheduleobj = {
          id: props.eidtData.obj.scheduleId,
          title: 'Default'
        };
        schedulelist.push(scheduleobj);
        list.push(obj);

        setdefaultScheduleData(list)
        setSchedule(schedulelist)
      }
    } else {
      setSelectedValue(null);
    }
  }, []);

const [CombinedMenuList,setCombinedMenuList] = useState([]);
console.log(CombinedMenuList);
  const getLinkedMenuInfoByMenuId = async () => {
    console.log(props);
  
    const response = await axios.get(
      apiAddress + "/api/Menu/GetLinkedMenuInfoByMenuID?menuId=" + EditData.id
    );
  
    const newLinkedMenus = [];
    let modifiednewLinkedSections = [];
    const LinkedData = response.data;
    console.log(LinkedData);
  
    var linkedMenuList = [];
    var linkedMenuList2 = [];
    var resList = [];
    var menuList = [];
    let modifiedResList = [];
    let modifiedMenuList = [];
  
    const uniqueResIds = new Set();
    const uniqueMenuIds = new Set();
    const uniqueResMIds = new Set();
    const uniqueMenuMIds = new Set();
  
    const combinedMenuList = [];

  // Process the main menu
  const mainMenu = {
    id: EditData.id,
    isDelivery: EditData.isDelivery,
    isCollectionOnly: EditData.isCollectionOnly,
    menuName: EditData.menuName,
    restaurantIsDelivery: EditData.restaurantIsDelivery,
    restaurantIsCollectionOnly: EditData.restaurantIsCollectionOnly,
  };
  combinedMenuList.push(mainMenu);

  // Process the linked menus
  LinkedData.forEach((dt) => {
    const linkedMenu = {
      id: dt.linkedMenuId,
      isDelivery: dt.isDelivery, // From API data
      isCollectionOnly: dt.isCollectionOnly, // From API data
      menuName: dt.menuResName, // Linked menu name
      restaurantIsDelivery: dt.linkedRestaurantIsDelivery, // From API data
       restaurantIsCollectionOnly: dt.linkedRestaurantIsCollectionOnly, // From API data
    };
    combinedMenuList.push(linkedMenu);
  });

  // Log and set the combined menu list
  console.log(combinedMenuList);
  setCombinedMenuList(combinedMenuList); 

    if (LinkedData.length > 0) {
      const liveResObj = {
        id: LinkedData[0].restaurantId,
        title: LinkedData[0].restaurantName,
        linkedMenuId: LinkedData[0].menuId,
        activeMenu: EditData.id,
      };
      modifiedResList.push(liveResObj);
  
      LinkedData.map((dt, i) => {
        var obj = {
          id: dt.linkedMenuId,
          title: dt.menuResName,
          linkedRestaurantId: dt.linkedRestaurantId,
          linkedMenuId: dt.linkedMenuId,
          linkedMenuTypeName: dt.linkedMenuTypeName || "",
        };
  
        var resObj = {
          id: dt.linkedRestaurantId,
          title: dt.linkedRestaurantName,
          linkedMenuId: dt.linkedMenuId,
          activeMenu: EditData.id,
        };
        linkedMenuList.push(obj);
  
        var obj2 = {
          id: dt.linkedMenuId,
          title: dt.menuResName + " | " + "Linked",
          linkedRestaurantId: dt.linkedRestaurantId,
          linkedMenuId: dt.linkedMenuId,
        };
  
        linkedMenuList2.push(obj2);
  
        const ResidExists = modifiedResList.some(
          (item) => item.id === resObj.id
        );
  
        if (!ResidExists) {
          modifiedResList.push(resObj);
        }
      });
    } else {
      console.log("No linked Item");
      var resObj = {
        id: EditData.restaurantId,
        title: EditData.restaurantName,
        linkedMenuId: EditData.id,
        activeMenu: EditData.id,
      };
  
      modifiedResList.push(resObj);
    }
  
    console.log(modifiedResList);
    setRestaurantAdded(modifiedResList);
    setinitRestaurantAdded(modifiedResList);
  
    setLinkedMenuDatas(linkedMenuList);
    setinitLinkedMenuDatas(linkedMenuList);
    setlinkedMenuAdded(linkedMenuList);
    setinitlinkedMenuAdded(linkedMenuList);
    setlinkedMenudatas2(linkedMenuList);
    setlinkedMenudatas3(linkedMenuList2);
  };
  const renderMenuTypes = () => {
    const allMenus = [{ ...EditData, isMain: true }, ...linkedMenuAdded];
  
    return (
      <>
        {allMenus.map((menu) => (
          <Grid container key={menu.id} style={{ marginLeft: "1.5rem" }}>
            <Grid item xs={3}>
              <Typography style={{ paddingTop: "1rem", marginTop: "0.3rem" }}>
                {menu.isMain ? EditData.menuName : menu.title}
              </Typography>
            </Grid>
            <Grid
              item
              xs={7}
              style={{ paddingTop: "0.5rem", marginBottom: "0.2rem", marginLeft: "3rem" }}
            >
              <Autocomplete
                multiple
                id={`menu-select-${menu.id}`}
                options={typrOfMenuDatas}
                getOptionLabel={(option) => option.title}
                // value={menu.isMain ? menuType[EditData.restaurantId] || [] : menuType[menu.id] || []}
                // onChange={(event, newValue) =>
                //   handleMenuChange(menu.isMain ? EditData.restaurantId : menu.id, newValue)
                // }
                value={menuType[menu.id] || []} 
                onChange={(event, newValue) => handleMenuChange(menu.id, newValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Select Menu Type" variant="outlined" />
                )}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                sx={{ width: "100%", paddingY: ".5rem" }}
              />
            </Grid>
          </Grid>
        ))}
      </>
    );
  };
  
  // useEffect(() => {
  //   var menuObj = typrOfMenuDatas.find(
  //     (x) => x.title == props.eidtData.obj.typeName
  //   );
  //   console.log(menuObj);
  //   setMenuTypeName(menuObj);
  //   console.log(props.eidtData);
  //   setinitManuType(menuObj);
  // }, [typrOfMenuDatas]);

console.log(linkedMenuAdded)
 
  
  useEffect(() => {
    if (props.eidtData?.obj?.typeName && typrOfMenuDatas.length > 0) {
      // Handle Main Menu
      const typeNamesArray = props.eidtData.obj.typeName.split(", ").map((type) => type.trim());
      const menuObjs = typrOfMenuDatas.filter((x) => typeNamesArray.includes(x.title));
  
      if (menuObjs.length > 0) {
        setMenuType((prevMenuType) => ({
          ...prevMenuType,
          [props.eidtData.obj.id]: menuObjs, // Store main menu types
        }));
      }
    }
  
    if (linkedMenuAdded.length > 0 && typrOfMenuDatas.length > 0) {
      // Handle Linked Menus
      const updatedLinkedMenuTypes = {};
      
      linkedMenuAdded.forEach((linkedMenu) => {
        if (linkedMenu.linkedMenuTypeName) {
          const linkedTypeNamesArray = linkedMenu.linkedMenuTypeName.split(", ").map((type) => type.trim());
          const linkedMenuObjs = typrOfMenuDatas.filter((x) => linkedTypeNamesArray.includes(x.title));
  
          if (linkedMenuObjs.length > 0) {
            updatedLinkedMenuTypes[linkedMenu.id] = linkedMenuObjs; // Store linked menu types
          }
        }
      });
  
      setMenuType((prevMenuType) => ({
        ...prevMenuType,
        ...updatedLinkedMenuTypes, // Merge linked menu types into state
      }));
    }
  }, [typrOfMenuDatas, props.eidtData, linkedMenuAdded]);
  



  useEffect(() => {
    let modifiedList = [];
    let modifiedList2 = [];
    modifiedList = [...linkedMenuAdded];
    modifiedList2 = [...linkedMenudatas3];
    modifiedList.push({
      id: EditData.id,
      title: EditData.menuName + " | " + EditData.restaurantName,
    });

    modifiedList2.push({
      id: EditData.id,
      title: EditData.menuName + " | " + EditData.restaurantName +" | "+ "Main",
      linkedRestaurantId: EditData.restaurantId
    });

    setlinkedMenudatas2(modifiedList);
    setlinkedMenudatas3(modifiedList2);
  }, [linkedMenuAdded]);

  console.log(props);

  //autocomplete

  const [userId, setUserId] = useState();
  const [initrestaurantAdded, setinitRestaurantAdded] = useState([]);
  const Restauranttoken = JSON.parse(localStorage.getItem("parentrestaurant"));
  const RestaurantLocaltoken = JSON.parse(localStorage.getItem("restaurant"));
  const tokenUserId = localStorage.getItem("gotasteadmintoken");

  
  const [initMenuName, setinitMenuName] = useState("");
  const [initIcon, setinitIcon] = useState();
  const [initManuType, setinitManuType] = useState();
  const loadRestaurantName = async () => {
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwt_decode(tokenUserId);

        setUserId(decodedData.UserId);

        // setTokenData(decodedData)
      } catch (error) {}
    }

    axios
      // .get(apiAddress + "/api/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=" + decodedData.UserId+"&restaurantId="+Restauranttoken.id)
      .get(
        apiAddress +
          `/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId=${Restauranttoken.id}`
      )
      .then((response) => {
        console.log(response);

        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.restaurantId,
            title: dt.restaurantName,
          };
          list.push(obj);
        });

        setRestaurantDatas(list);
        //setRestaurantAdded(props);

        //setRestaurantAdded([{id:RestaurantLocaltoken.id,title:RestaurantLocaltoken.name}]);

        //setinitRestaurantAdded([{id:RestaurantLocaltoken.id,title:RestaurantLocaltoken.name}]);
        console.log(initrestaurantAdded);
      });
  };
  console.log(restaurantAdded);

  const findAdditionalObjects = (arr1, arr2) => {
    return arr2.filter((bObj) => !arr1.some((aObj) => aObj.id === bObj.id));
  };

  var restaurantAddedvalue = (props) => {
    //setRestaurantAdded(props);
    var selectedList = [];

    props.map((obj) => {
      console.log(restaurantDatas);
      const object = restaurantDatas.find((x) => x.id == obj.id);
      const linkedObject = restaurantAdded.find((x) => x.id == obj.id);
      console.log(object);
      const newObject = {
        id: object?.id,
        title: object?.title,
        linkedMenuId: linkedObject?.linkedMenuId ?? null,
        activeMenu : EditData.id
      };
      selectedList.push(newObject);
    });
    console.log(selectedList);
    setRestaurantAdded(selectedList);
    //setMenuSelected(props);
    // setMainsectionErr(false);
  };
  const [newAddedRestaurant, setnewAddedRestaurant] = useState([]);

  function findNotMatched(array1, array2) {
    const notMatched = [];

    for (let i = 0; i < array1.length; i++) {
      const element = array1[i];

      if (array2.find((x) => x.id == element.id) == undefined) {
        notMatched.push(element);
      }
    }

    return notMatched;
  }
  useEffect(() => {
    console.log(restaurantAdded);
    console.log(initrestaurantAdded);
    if (restaurantAdded.length > initrestaurantAdded.length) {
      console.log("Length increased");
      var newAddedRes = findNotMatched(restaurantAdded, initrestaurantAdded);
      setnewAddedRestaurant(newAddedRes);

      console.log(newAddedRes);

      console.log(newAddedRes);
      console.log(newAddedRestaurant);
      setopenMenuCopyDilaog(true);
    } else if (restaurantAdded.length < initrestaurantAdded.length) {
      console.log("Length Decreased");
      var cancelledRes = findNotMatched(initrestaurantAdded, restaurantAdded);
      setcancelledRestaurant(cancelledRes);
      console.log(cancelledRes);
      setopenArchiveDilaog(true);
      setArchiveStatus("Bulk Archive")
      setArchiveDialogType("Menu Archive")
    }
  }, [restaurantAdded]);

  useEffect(() => {

    if (linkedMenuAdded.length < initlinkedMenuAdded.length) {
      console.log("Length Decreased");
      var cancelledRes = findNotMatched(initlinkedMenuAdded, linkedMenuAdded);
      setcancelledRestaurant(cancelledRes);
      console.log(cancelledRes);
      setArchiveDialogType("Menu Archive")
      setopenArchiveDilaog(true);
      setArchiveStatus("Single Archive")
    }
  }, [linkedMenuAdded]);

  useEffect(() => {
    console.log(restaurantAdded);
  }, [restaurantAdded]);

  const findRemovedElement = (fullArr, partialArr) => {
    const partialIds = new Set(partialArr.map((item) => item.id));
    return fullArr.find((item) => !partialIds.has(item.id));
  };

  const linkedMenuAddedvalue = (props) => {
    setlinkedMenuAdded(props);

    const removedElement = findRemovedElement(linkedMenuAdded, props);
    const newRestaurantAdded = restaurantAdded.filter(
      (item) => item.linkedMenuId !== removedElement.id
    );
    setRestaurantAdded(newRestaurantAdded);

    // setRestaurantErr(false);
    // loadKeyword(props);
  };

  const [openArchiveDilaog, setopenArchiveDilaog] = useState(false);
  const [openMenuCopyDilaog, setopenMenuCopyDilaog] = useState(false);
  const [ArchiveDialogType, setArchiveDialogType] = useState("");
  const [ArchiveStatus, setArchiveStatus] = useState("");

  const [selectedRowId, setSelectedRowId] = useState();
  const [cancelledRestaurant, setcancelledRestaurant] = useState([]);

  const [openMenuCloseConfirmaitonModal, setopenMenuCloseConfirmaitonModal] =
    useState(false);
  //autocomplete

  const [logoImg, setlogoImg] = useState([]);

  const handleDeleteImage = (index: number) => {
    const updatedImages = [...state.selectedImages];
    updatedImages.splice(index, 1);
    setState({ selectedImages: updatedImages });
  };

  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 1 - state.selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);
      setlogoImg(filesToUpload);
      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        const reader = new FileReader();
        reader.onloadend = () => {
          imagesArray.push(reader.result as string);
          if (imagesArray.length === filesToUpload.length) {
            const updatedImages = [...state.selectedImages, ...imagesArray];
            setState({ selectedImages: updatedImages });
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const [openLeosModal, setopenLeosModal] = useState(false);
  console.log(RestaurantLocaltoken);
  // const [restaurantAdded, setRestaurantAdded] = useState([
  //   { id: RestaurantLocaltoken.id, title: RestaurantLocaltoken.name },
  // ]);
  const [tempRestaurantAdded, setTempRestaurantAdded] = useState();
  // console.log(restaurantAdded);

  const setKitchenInitData = (initData) => {
    // if ( initData.length > 0) {
    // Ensure props.editData and its nested properties exist

    const kitchenObj = initData?.find(
      (x) => x.id === props.editData.obj.kitchenId
    );

    console.log(kitchenObj);
    setMenuIds(kitchenObj);

    // } else {
    //   console.error('initData is empty or first item has no id');
    // }

    console.log(initData);
  };

  const loadMenuData = async () => {
    var list = [];
    var kitchenList = [];

    var Alllist = [];
    var filteredList = [];

    console.log(restaurantAdded);
    const idList = restaurantAdded.map((d) => d.id);

    if (idList.length > 0) {
      try {
        const response = await axios.post(
          apiAddress + "/api/Kitchen/GetAllKitchensByRestaurantIdList",
          idList
        );
        console.log(response);
        console.log(props);

        response.data.forEach((dt, i) => {
          var obj = {
            id: dt.id,
            title: dt.name,
            img: dt.logoUrl,
            restaurantName: dt.restaurantName,
            restaurantId: dt.restaurantId,
          };
          if (obj.id === props.eidtData.obj.kitchenId) {
            kitchenList.push(obj);
          }

          list.push(obj);
          dt.MenuRestaurantMapperLists = [];
          Alllist.push(dt);
          console.log(Alllist);
        });

        setAllMenuData(Alllist);
        console.log(list);
        setMenuData(list);
        setMenuIds(kitchenList);
        setinitKitchenId(kitchenList);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      setAllMenuData([]);
      setMenuData([]);
      // setKitchenInitData([]);
    }

    console.log(menuIds);
  };

  useEffect(() => {
    loadMenuData();
  }, [restaurantAdded]);

  const [openLinkModal, setopenLinkModal] = useState(false);
  const hanldeLinkmodalclose = async () => {
    setopenLinkModal(false);
    await getLinkedMenuInfoByMenuId()
  }
  const [Schedule, setSchedule] = React.useState([]);
  const getSchedule = (props) => {
    console.log(props)
    setSchedule(props);
    // Schedule.push(props)
  };

  const [defaultScheduleData, setdefaultScheduleData] = useState([]);

  const [openMenuSchedulerSelectionDialog, setopenMenuSchedulerSelectionDialog] = useState(false);
  const handleMenuSchedularDialogOpen = () => {
    setopenMenuSchedulerSelectionDialog(true)
  }
  const handleMenuSchedulerDialogClose = () => {
    setopenMenuSchedulerSelectionDialog(false)
  }


  const [openEditDeliveryDialog, setopenEditDeliveryDialog] = useState(false);
  const handleDeliveryDialogOpen = () => {
    setopenEditDeliveryDialog(true)
  }
  const handleDeliveryDialogClose = () => {
    setopenEditDeliveryDialog(false)
  }


  // const isDeliveryEnabled = CombinedMenuList.some((menu) =>
  //   menuType[menu.id]?.some((type) => type?.title?.toLowerCase() === "delivery")
  // ); // Check if any menu has "Delivery" type
  
  const closeLoadingModal = () => {
    SetloadingModal(false);
  };

  return (
    <div>
      <React.Fragment>
        <Dialog
          maxWidth={"lg"}
          className="addSectionDialog"
          open={props.open}
          onClose={handleClose}
        >
          <ToastContainer></ToastContainer>
          <LoadingView open={loadingModal} close={closeLoadingModal} />
          <SweetAlertModal
            headerText={"Do you want to leave without saving?"}
            bodyText={"All changes made will be lost"}
            open={openMenuCloseConfirmaitonModal}
            onyes={handleEditDialogClose}
            close={() => {
              setopenMenuCloseConfirmaitonModal(false);
            }}
            id={2}
          />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  <div>
                    <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                  </div>

                  <span style={{ color: "#2a7fd4" }}>
                    GoTaste :- {dialogType}
                  </span>
                </div>
              </DialogTitle>

              {/* {dialogType === 'sub' && <DialogTitle>Sub Menu</DialogTitle>} */}
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button onClick={handleClose}>
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
            <div>
              {/* <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "2rem" }}>
                    Linked Menus
                  </Typography>
                </Grid>
                <Grid item xs={8} style={{ paddingTop: "1rem" }}>
                  <AutoCompleteMultiSelect
                    id={2}
                    placeholder={"Linked Menus"}
                    datas={LinkedMenuDatas}
                    value={linkedMenuAddedvalue}
                    val={linkedMenuAdded}
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  className="AddItemplusIcon"
                  style={{ paddingTop: '1.5rem' }}
                  onClick={() => setopenLinkModal(true)}
                >
                  <button className="modalAddButton">
                    +Link Menus
                  </button>
                </Grid>
              </Grid> */}
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "2rem" }}>
                    Restaurant
                  </Typography>
                </Grid>
                <Grid item xs={8} style={{ paddingTop: "1rem" }}>
                  <AutoCompleteMultiSelect
                    id={2}
                    placeholder={"Restaurant"}
                    datas={restaurantDatas}
                    value={restaurantAddedvalue}
                    val={restaurantAdded}
                  />
                </Grid>
              </Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "2rem" }}>Name</Typography>
                </Grid>
                <Grid item xs={8}>
                  <TextField
                    label="Name"
                    value={keyword}
                    onChange={handleKeyword}
                    fullWidth
                    margin="normal"
                    InputLabelProps={{ sx: { color: "#371B17" } }}
                  />
                </Grid>
              </Grid>
              {/* <Grid container sx={{ padding: '0.5rem' }}>
                                <Grid item xs={2}>
                                    <Typography style={{ paddingTop: '1rem' }}>Icon</Typography>
                                </Grid>
                                <Grid item xs={8}>


                  <Autocomplete
                    id="country-select-demo"
                    // sx={{ width: 300 }}
                    options={imageMap}
                    value={selectedValue}
                    onChange={handleAutocompleteChange}
                    autoHighlight
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        <img
                          src={option.icon}
                          alt=""
                          style={{ width: '2rem' }}
                        />
                        {option.label}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select a icon"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: 'new-password', // disable autocomplete and autofill
                        }}
                      />
                    )}

                                    />
                                </Grid>
                             
                            </Grid>  */}

              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>Logo</Typography>
                </Grid>
                <Grid xs={9}>
                  <Button
                    variant="contained"
                    component="label"
                    //   color="primary"
                    className="uploadButton"
                    // style={{ backgroundColor: 'white', color: 'gray' }}
                  >
                    <img
                      src={galleryIcon}
                      alt="photo"
                      // style={{ width: '2rem' }}
                    />
                    Upload
                    <input
                      hidden
                      accept="image/*"
                      multiple
                      type="file"
                      onChange={handleImageUpload}
                      disabled={state.selectedImages.length >= 1}
                    />
                  </Button>
                </Grid>

                {/* image show start */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={9}>
                    <Grid container spacing={2}>
                      {console.log(state)}
                      {state.selectedImages.map((image, index) => (
                        <Grid item xs={2} sm={2} md={2} key={index}>
                          {/* <Paper> */}
                          {console.log(image)}

                          <div
                            style={{
                              position: "relative",
                              paddingTop: "20px",
                            }}
                          >
                            <img
                              src={image}
                              alt={`Preview ${index + 1}`}
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "cover",
                              }}
                            />
                            <IconButton
                              style={{
                                position: "absolute",
                                top: "-6px",
                                right: "-23px",
                                color: "gray",
                              }}
                              onClick={() => handleDeleteImage(index)}
                            >
                              <CancelIcon />
                            </IconButton>
                          </div>
                          {/* </Paper> */}
                        </Grid>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>
                {/* image show end */}
              </Grid>

              {/* <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Type Of Menu
                  </Typography>
                </Grid>
                
                <Grid item xs={8} style={{ paddingTop: "1rem" }}>
                  {renderMenuTypes()}
                </Grid>

                <Grid item xs={2} className="AddItemplusIcon">
                </Grid>
              </Grid> */}
              {/* <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography style={{ paddingTop: "1rem" }}>
                    Kitchen
                  </Typography>
                </Grid>
                <Grid item xs={8} style={{ paddingTop: "1rem" }}>
                  <AutoCompleteMultiSelect
                    id={88}
                    label={props.title}
                    placeholder={"Kitchen"}
                    datas={menuData}
                    value={addValue}
                    val={menuIds}
                  />
                </Grid>
              </Grid> */}
              {/* <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={12}>
                  <SchedulerComponent
                      from="discount"
                      getSchedule={getSchedule}
                      showSchedulerTable={true}
                      defaultData={defaultScheduleData}
                    />
                  </Grid>
              </Grid> */}
              {/* <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}>
                  <Typography>Scheduler</Typography>
                </Grid>
                <Grid item xs={8}>
                        <button style={{textAlign:"left"}}
                          className="modalAddButton"
                          onClick={handleMenuSchedularDialogOpen}
                        >
                          
                          Edit Scheduler
                        </button>
                </Grid>
              </Grid> */}

              {/* <Grid container spacing={2} sx={{ padding: '0.5rem' }}>
                <Grid item xs={2} sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography>Delivery:</Typography>
                </Grid>
                <Grid item xs={9}>
                  <Grid container>
                      <Grid item xs={8}>
                        <button className="modalAddButton" onClick={handleDeliveryDialogOpen} style={{ textAlign: "left" }}>
                          Edit Delivery
                        </button>
                        <EditMenuDelivery
                          open={openEditDeliveryDialog}
                          onClose={handleDeliveryDialogClose}
                          CombinedMenuList={CombinedMenuList}
                          onHandleAddItem={handleAddItem}
                          menuType={menuType}
                        />
                      </Grid>
                  </Grid>
                </Grid>
              </Grid> */}


              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={12}>
                  <div className="d-flex justify-content-end">
                    <Button onClick={onClickUpdate}>
                      Update
                    </Button>
                  </div>
                </Grid>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid container sx={{ padding: "0.5rem" }}>
                <Grid item xs={2}></Grid>
                <Grid item xs={9}>
                  {/* {dialogType === 'add' && <SectionTable selectedValue={selectedData} selectedSectionValue={selectedData} />} */}
                  {dialogType === "sub" && (
                    <SectionTableSubSection
                      selectedValue={selectedData}
                      selectedSectionValue={selectedData}
                    />
                  )}
                </Grid>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <CustomDialog
        open={openIconDilaog}
        dialogTitle={"Add Icon"}
        onClose={handleDialog}
      />
      <AddRestaurantDialog
        open={openRestaurantDialog}
        onHandleAddItem={handleAddItem}
        title={props.title}
      />
      {openArchiveDilaog && (
      <ArchiveDialog
        open={openArchiveDilaog}
        dialogType={ArchiveDialogType}
        onHandleArchiveItem={handleAddArchiveItem}
        onClose={handleDialog}
        id={selectedRowId}
        cancledRes={cancelledRestaurant}
        Linkdata={LinkedMenuDatas}
        Status={ArchiveStatus}
      />
      )}
      {openMenuCopyDilaog && (
      <MenuCopyDialog
        open={openMenuCopyDilaog}
        dialogType={ArchiveDialogType}
        onHandleAddItem={handleAddArchiveItem}
        onClose={handleDialog}
        //id={newAddedRestaurant}
        cancledRes={linkedMenudatas2}
        addedNewRes={newAddedRestaurant}
      />
      )}
      {openLinkModal && (
      <MenuLinkDialog
        open={openLinkModal}
        linkmodalclose={hanldeLinkmodalclose}
        Openfrom={"Edit"}
      />
      )}

    {openMenuSchedulerSelectionDialog && (
      <MenuSchedulerSelectDialog
        open={openMenuSchedulerSelectionDialog}
        //restaurantSelected={selectedMenuDatas}
        //onHandleAddItem={handleAddItem}
        onClose={handleMenuSchedulerDialogClose}
        //onToggleSwitch={handleSwitchToggle}
        //onSave={(data) => setScheduleSelections(data)} 
        //prevScheduleSelecection={scheduleSelections}
        cancledRes={linkedMenudatas3}
      />
      )}
    </div>
  );
}

export default EditMenuDialog;
